import * as Yup from "yup";

export const envOpeningTicketValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("Le prénom est requis"),
  lastName: Yup.string().required("Le nom est requis"),
  description: Yup.string().required("La description est requise"),
  projects: Yup.array().min(1, "Vous devez selectionner au moins un projet"),
});
